/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiBilling.ts                    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-billing";

export class AutogenModelEdiBilling<RowType extends ModelRow> extends Endpoint<RowType, RowEdiBillingFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiBilling extends ModelRow<RowEdiBillingFields> {
	constructor(values?: Partial<RowEdiBillingFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiBillingFields {
	agent: string;
	alt_partner_id: string;
	autorate_status: string;
	batch: number;
	bill_date: Date;
	bill_tid: number;
	bill_type: string;
	billing_empty_distance: number;
	billing_empty_distance_um: string;
	billing_id: string;
	billing_loaded_distance: number;
	billing_loaded_distance_um: string;
	billing_user_id: string;
	blnum: string;
	booking_number: string;
	broker: string;
	carrier_id: string;
	carrier_tractor: string;
	carrier_trailer: string;
	cc_pro_nbr: string;
	commodity: string;
	commodity_descr: string;
	company_id: string;
	consignee_ref_no: string;
	consignee_stop_id: string;
	container: string;
	correction_ind: string;
	create_date: Date;
	currency: string;
	currency_iso_id: string;
	currency_type_id: string;
	customer_ediloc: string;
	customer_id: string;
	delivery_date: Date;
	direction: string;
	dist_include_split: string;
	distance: number;
	distance_um: string;
	driver_id: string;
	edi_commodity_id: string;
	edi_equip_type_id: string;
	edi_error: number;
	edi_transfered: string;
	entered_user_id: string;
	equipment_type_id: string;
	error_text: string;
	excisetax_total: number;
	excisetax_total_c: string;
	excisetax_total_d: Date;
	excisetax_total_n: number;
	excisetax_total_r: number;
	external_invoiceno: string;
	factoring_exp_date: Date;
	factoring_id: string;
	fixed_charge_label: string;
	fixed_charge_seg_alloc_code: string;
	freight_class: string;
	frt_grp_pro_nbr: string;
	func_ack_batch: number;
	func_ack_id: string;
	func_ack_rec: string;
	func_ack_rec_date: Date;
	func_ack_status: string;
	gs06_group_cntlno: string;
	gs_date_time: Date;
	handling_code1: string;
	handling_code2: string;
	ic_company_from: string;
	ic_movement_from: string;
	ic_order_from: string;
	id: string;
	intercompany: string;
	invoice_no: number;
	invoice_no_string: string;
	invoice_recv_date: Date;
	invoiced_flag: string;
	is_balance_due: string;
	is_dedicated_bill: string;
	is_fixed: string;
	is_intercompany: string;
	is_rebill: string;
	is_split_bill: string;
	linehaul_chg: number;
	linehaul_chg_c: string;
	linehaul_chg_d: Date;
	linehaul_chg_n: number;
	linehaul_chg_r: number;
	lock_miles: string;
	master_order_id: string;
	minimum_weight: number;
	minimum_weight_um: string;
	modified_date: Date;
	modified_user_id: string;
	movement_id: string;
	order_id: string;
	order_type_id: string;
	other_charge: number;
	other_charge_c: string;
	other_charge_d: Date;
	other_charge_n: number;
	other_charge_r: number;
	partner_id: string;
	pay_gross: number;
	pay_gross_c: string;
	pay_gross_d: Date;
	pay_gross_n: number;
	pay_gross_r: number;
	payment_method: string;
	pieces: number;
	pieces_qual: string;
	port: string;
	post_key: string;
	post_module: string;
	printed: string;
	pro_nbr: string;
	purchase_order_no: string;
	rate: number;
	rate_id: number;
	rate_type: string;
	rate_unit_desc: string;
	rating_method: string;
	rating_type: string;
	rating_units: number;
	ready_to_process: string;
	ready_to_send: string;
	rebilled: string;
	reference_id: string;
	revenue_id: string;
	round_trip_flag: string;
	route_code: string;
	route_qual: string;
	scac: string;
	service_code: string;
	ship_date: Date;
	ship_match_descr: string;
	ship_match_type: string;
	shipment_id: string;
	shipper_stop_id: string;
	splc: string;
	st02_trxset_cntlno: string;
	status: string;
	total_charges: number;
	total_charges_c: string;
	total_charges_d: Date;
	total_charges_n: number;
	total_charges_r: number;
	totalcharge_and_excisetax: number;
	totalcharge_and_excisetax_c: string;
	totalcharge_and_excisetax_d: Date;
	totalcharge_and_excisetax_n: number;
	totalcharge_and_excisetax_r: number;
	tractor_id: string;
	trailer2_id: string;
	trailer_id: string;
	trans_count: number;
	transfer_date: Date;
	transport_method: string;
	version: string;
	vessel: string;
	void_credit_immediately: string;
	weight: number;
	weight_qual: string;
	weight_um: string;
}

